<p-toast position="bottom-right"></p-toast>
<p-progressSpinner [hidden]="!(this.loading || this.loadingProgressValue < 100)"></p-progressSpinner>
<p-progressBar [value]="loadingProgressValue | number:'1.0-0'"
               [hidden]="false||loadingProgressValue>=100"
               ></p-progressBar>
<small class="p-field col-12 p-invalid"
       [textContent]="globalErrorMessage|translate"></small>
<small class="p-field col-12 p-info"
       [textContent]="globalInfoMessage|translate"></small>
<ng-template ngFor let-fieldGroup [ngForOf]="formConfig" let-groupIndex="index">
  <p-panel *ngIf="!fieldValueMap['hiddenGroup-' + groupIndex]
                    &&fieldGroup.group&&fieldGroup.group.length>0"
           header="{{ fieldGroup.group&&fieldGroup.group.length>0?('page.' + transPartKey + '.form.group_title.' + fieldGroup.group | translate):'' }}"
           #pPanel
           [toggleable]="true"
           (onAfterToggle)="sizeChanged.emit($event)"
           [collapsed]="fieldGroup.collapsed?fieldGroup.collapsed:false">
    <div class="p-fluid p-formgrid grid">
      <ng-template ngFor let-fieldConfig [ngForOf]="fieldGroup.fields" let-fieldIndex="index"
                   *ngIf="!fieldValueMap['hiddenGroup-' + groupIndex]">
        <div *ngIf="formRecord&&!fieldValueMap['hiddenField-'+ groupIndex+'_' + fieldIndex]"
             [class]="(fieldConfig.class?fieldConfig.class:'') +
         ' field p-field'+(!fieldConfig.labelCheckbox&&fieldConfig.type===FieldTypes.CHECKBOX?'-checkbox':'')
         +(fieldConfig.column>0?' col-12 md:col-'+fieldConfig.column:' no-col')">
          <!--        LABEL -->
          <label *ngIf="fieldConfig.field && fieldConfig.type!=FieldTypes.CHECKBOX" [for]="fieldConfig.field"
                 [className]="fieldConfig.required===true?'field-required':''">
            {{fieldConfig.label ? fieldConfig.label : 'page.' + this.transPartKey + '.form.' + fieldConfig.field | translate}}
            <!--              {{ 'page.' + transPartKey + '.form.' + fieldConfig.field | translate }}-->
          </label>
          <label *ngIf="fieldConfig.labelCheckbox" [for]="fieldConfig.field+'_checkbox'" [class]="'label-checkbox'">
            {{'page.' + this.transPartKey + '.form.label-checkbox' | translate}}
          </label>
          <p-checkbox *ngIf="fieldConfig.labelCheckbox" value="false"
                      [binary]="true"
                      [class]="'label-checkbox'"
                      [(ngModel)]="formRecord[fieldConfig.field+'_active']"
                      [inputId]="fieldConfig.field+'_checkbox'"
                      (onChange)="fieldConfig.labelCheckboxChanged(fieldConfig, $event)"></p-checkbox>
          <app-cc-field-dispatcher #ccSubForm [loading]="loading" [loadingProgressValue]="loadingProgressValue"
                                   [transPartKey]="transPartKey"
                                   [(formRecord)]="formRecord" [fieldConfig]="fieldConfig"
                                   (formRecordChange)="recordChanged()"></app-cc-field-dispatcher>
        </div>
      </ng-template>
    </div>
  </p-panel>
  <div *ngIf="!fieldValueMap['hiddenGroup-' + groupIndex]
                    &&(!fieldGroup.group||fieldGroup.group.length==0)"
       class="p-fluid p-formgrid grid no-header">
    <ng-template ngFor let-fieldConfig [ngForOf]="fieldGroup.fields" let-fieldIndex="index"
                 *ngIf="!fieldValueMap['hiddenGroup-' + groupIndex]">
      <div *ngIf="formRecord&&!fieldValueMap['hiddenField-'+ groupIndex+'_' + fieldIndex]"
           [class]="(fieldConfig.class?fieldConfig.class:'') +
         ' field p-field'+(!fieldConfig.labelCheckbox&&fieldConfig.type===FieldTypes.CHECKBOX?'-checkbox':'')
         +(fieldConfig.column>0?' col-12 md:col-'+fieldConfig.column:' no-col')">
        <!--        LABEL -->
        <label *ngIf="fieldConfig.field && fieldConfig.type!=FieldTypes.CHECKBOX" [for]="fieldConfig.field"
               [className]="fieldConfig.required===true?'field-required':''">
          {{fieldConfig.label ? fieldConfig.label : 'page.' + this.transPartKey + '.form.' + fieldConfig.field | translate}}
        </label>
        <label *ngIf="fieldConfig.labelCheckbox" [for]="fieldConfig.field+'_checkbox'" [class]="'label-checkbox'">
          {{'page.' + this.transPartKey + '.form.label-checkbox' | translate}}
        </label>
        <p-checkbox *ngIf="fieldConfig.labelCheckbox" value="false"
                    [binary]="true"
                    [class]="'label-checkbox'"
                    [(ngModel)]="formRecord[fieldConfig.field+'_active']"
                    [inputId]="fieldConfig.field+'_checkbox'"
                    (onChange)="fieldConfig.labelCheckboxChanged(fieldConfig, $event)"></p-checkbox>
        <app-cc-field-dispatcher #ccSubForm [loading]="loading" [loadingProgressValue]="loadingProgressValue"
                                 [transPartKey]="transPartKey"
                                 [(formRecord)]="formRecord" [fieldConfig]="fieldConfig"
                                 (formRecordChange)="recordChanged()"></app-cc-field-dispatcher>
      </div>
    </ng-template>
  </div>
</ng-template>
